// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-down-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5354 10.7345L11.9999 14.27L8.46436 10.7345","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronDownSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-down-s',
    ref,
    icon: element,
  },
));

ChevronDownSIcon.displayName = 'ChevronDownSIcon';

export default ChevronDownSIcon;
